import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { query } from 'lit/decorators/query.js';
import { localized, msg } from "@lit/localize";
import { UsosDialog } from ".";
import type { ElementInternals } from "element-internals-polyfill/dist/element-internals";
import style from './help-dialog.scss';
import '../icon/usos-icon';

/**
 * "?" button opening usos-dialog with help.
 *
 * @slot - Slot for usos-dialog content
 */
@customElement('help-dialog')
@localized()
export class HelpDialog extends LitElement {

    static override styles = style;

    /** Title for usos-dialog */
    @property({attribute: 'dialog-title'}) dialogTitle = '';

    @query('usos-dialog') private _dialog!: UsosDialog;

    private _internals: ElementInternals;

    constructor() {
        super();
        this._internals = this.attachInternals();
        this._internals.role = 'button';
    }

    override render() {
        const title = this.dialogTitle || msg('Pomoc');
        return html`
            <usos-icon is-button @click=${this.onClick} icon-name="help" .label=${title}></usos-icon>
            <usos-dialog>
                <span slot='title'>${title}</span>
                <slot></slot>
            </usos-dialog>
        `;
    }

    protected override updated() {
        this._internals.ariaLabel = this.dialogTitle || msg('Pomoc');
    }

    private onClick() {
        this._dialog.open();
    }
}

declare global {
    interface HTMLElementTagNameMap {
      "help-dialog": HelpDialog,
    }
}
